import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'dmmp-website-search-filter',
  templateUrl: './website-search-filter.component.html'
})
export class WebsiteSearchFilterComponent implements OnInit {
  @Input() identifier: string
  @Input() data
  @Input() module
  @Input() result
  @Input() urlPayment: string
  @Input() privateKey: string
  @Output() clearResult = new EventEmitter()
  @Output() search = new EventEmitter()
  @Output() page = new EventEmitter()
  searchSubmit: FormGroup
  resultLabelTitle = 'Search results for:'
  resultLabel

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router) {
    this.searchSubmit = this.formBuilder.group({
      search: ['', Validators.required],
      program: [''],
      university: [''],
    })
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['q']) {
        this.searchSubmit.get('search').setValue('')
        this.searchSubmit
          .get('search')
          .setValue(params['q'].split('-').join(' '))
        this.resultLabel = params['q'].split('-').join(' ')
        this.onSubmit()
      } else {
        this.clearResult.emit()
      }
    })
  }

  onSubmit() {
    this.router.navigate(['.'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        q: this.replaceSpace(this.searchSubmit.value['search']),
      },
    })
    const searchLabel = this.searchSubmit.value['search']
      ? `${this.searchSubmit.value['search']}`
      : ''
    const programLabel = this.searchSubmit.value['program']
      ? `${searchLabel ? ', ' : ''}${this.getParamsForm(this.searchSubmit.value['program'])[1]}`
      : ''
    const universityLabel = this.searchSubmit.value['university']
      ? `${programLabel || searchLabel ? ', ' : ''}${this.getParamsForm(this.searchSubmit.value['university'])[1]}`
      : ''
    this.resultLabel = `${searchLabel}${programLabel}${universityLabel}`

    const searchInput = this.searchSubmit.value['search']
      ? `(title:(${this.searchSubmit.value['search']}))`
      : ''
    const program = this.searchSubmit.value['program']
      ? `${searchInput ? 'AND' : ''}(content_category:(${this.getParamsForm(this.searchSubmit.value['program'])[0]}))`
      : ''
    const university = this.searchSubmit.value['university']
      ? `${program || searchInput ? 'AND' : ''}(content_course_university:(${this.getParamsForm(this.searchSubmit.value['university'])[0]}))`
      : ''
    this.search.emit(`${searchInput}${program}${university}`)
  }

  replaceSpace(words) {
    return words.split(' ').join('-')
  }

  reactiveInput() {
    if (this.searchSubmit.value['search'].length >= 3 || this.searchSubmit.value['search'].length === 0) {
      this.onSubmit()
    }
  }

  getParamsForm(value) {
    return value.split('|')
  }
}


